import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import { COUNTRY_PHONE_CODE, EMAIL } from "../../appconstants";
import { API } from "../../api";
import {
  FlexContainer,
  H1Text,
  Hr,
  Input,
  InputWrapper,
  LabelText, SpanText,
  SubmitButton,
  Img,
  Text,
} from "../../design";
import {
  AchPannel,
} from "../../widgetDesign";
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';
import ReCAPTCHA from 'react-google-recaptcha';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import ACHIcon from "../../assets/imgs/ach-bank.svg";
import { AmountDivideByHundred } from "../../helper";

type Props = {
  errorMsg: string,
  errorHeader: string,
  submit: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  headerText: string,
  accountId: string,
  paymentPageGId: string,
  buttonText: string,
  customerValidation: boolean,
  customerDisabled: boolean,
  requiredPhone: boolean,
  alpha2: string,
  disableButtonText: string,
  iavUrl: string,
  paymentLinkId: string,
  planStartDate: Object,
  currentDateObject: Object,
  cancel: Function,
  showCancelBtn: boolean,
  cancelButtonText: string,
  invoiceGid: string,
  sitekey: String,
  publicKey: String,
  isCaptchaEnabled: Boolean,
  serviceFee: Number,
  serviceFeeRate: Number,
  tip: Number,
  serviceFeeRateVal: Number,
  serviceFeeVal: Number,
  prefix: string,
  tax: Number,
  discount: Number,
  totalPayable: Number,
  subTotal: Number,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
  surcharge: Number,
}

const BankPayment = (props: Props) => {
  const { submit, preFillCustomer, customerDisabled, prefix, sitekey, discount, accountId, paymentPageGId, serviceFee, serviceFeeRate, tip,
    headerText, buttonText, errorHeader, errorMsg, requiredPhone, publicKey, isCaptchaEnabled, serviceFeeRateVal, amount, serviceFeeVal, subTotal,
    customerValidation, alpha2, disableButtonText, planStartDate, currentDateObject, showCancelBtn, cancel, cancelButtonText, tax, totalPayable,
    netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled, surcharge } = props;
  const [errorMessage, setErrorMessage] = useState('');
  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';
  const [fundingSourceId, setfundingSourceId] = useState();
  const [loading, setLoading] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);
  const [recaptchaToken, setRecaptchToken] = useState(null);
  const [showCaptchError, setShowCaptchError] = useState(null);
  const [selectedID, setSelectedID] = useState();
  const [addButton, setAddButton] = useState(true)

  const [name, setName] = useState();
  const [redirect, setRedirect] = useState(false);
  const [response, setResponse] = useState(false);
  const [clientSecretKey, setClientSecret] = useState('');

  useEffect(() => {
    if (clientSecretKey && publicKey) {
      const stripeData = (sessionStorage.getItem("stripeRes"));
      setRedirect(false);
      if (stripeData && stripeData === 'No accounts were linked') {
        setClientSecret('');
        setErrorMessage(stripeData);
        setShowErrorMessage(true);
        const accountGid = (preFillCustomer && preFillCustomer.account) ? (preFillCustomer && preFillCustomer.account && preFillCustomer.account.gid) : accountId;
        if (preFillCustomer && preFillCustomer.customer) {
          const customerName = preFillCustomer && preFillCustomer.customer && preFillCustomer.customer.name;
          const customerEmail = encodeURIComponent(preFillCustomer && preFillCustomer.customer && preFillCustomer.customer.email);
          const payload = {
            customerName,
            customerEmail,
            accountGid,
          }
          getClientSecret(payload);
        }
        sessionStorage.removeItem("stripeRes")
      } else if (stripeData && stripeData === 'This Financial Connections Session client_secret has expired.') {
        setErrorMessage(stripeData);
        setShowErrorMessage(true);
      } else if (stripeData) {
        if (stripeData === 'This is not a valid Financial Connections Session client_secret.') {
          setErrorMessage(stripeData);
          setShowErrorMessage(true);
        } else {
          const res = JSON.parse(stripeData);
          const newRes = res.map(data => data);
          setResponse(true);
          setName(newRes);
          setShowErrorMessage(false);
        }
      }
    }
  }, [clientSecretKey, redirect, response]);

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
  } = useForm();

  useEffect(() => {
    if (accountId) {
      const customer = preFillCustomer && preFillCustomer.customer
      const phone = customer && customer.phoneNumber && AsYouType(customer.phoneNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      reset({
        name: customer && customer.name || "",
        email: customer && customer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
      })
    } else if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      reset({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
      })
    }
  }, [reset, preFillCustomer, alpha2]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    }
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const phoneCustomStyles = {
    control: base => ({
      ...base,
      height: 32,
      minHeight: 32,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important'
    }),
  };

  const disableStyles = {
    control: base => ({
      ...base,
      height: 32,
      minHeight: 32,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  const getClientSecret = async (data) => {
    const { customerName, customerEmail, accountGid } = data;
    try {
      const { data: { entity } } = await API.get(`/account/${accountGid}/stripe-fca-session?customerName=${customerName}&customerEmail=${customerEmail}`);
      setClientSecret(entity && entity.client_secret);
      //setShowErrorMessage(false);
    } catch (e) {
      console.log(e, 'error');
      setShowErrorMessage(true);
      setErrorMessage('Error While creating Session');
    }
  };

  useEffect(() => {
    const accountGid = (preFillCustomer && preFillCustomer.account) ? (preFillCustomer && preFillCustomer.account && preFillCustomer.account.gid) : accountId;
    if (preFillCustomer && preFillCustomer.customer) {
      const customerName = preFillCustomer && preFillCustomer.customer && preFillCustomer.customer.name;
      const customerEmail = encodeURIComponent(preFillCustomer && preFillCustomer.customer && preFillCustomer.customer.email);
      const payload = {
        customerName,
        customerEmail,
        accountGid,
      }
      getClientSecret(payload);
    }
  }, []);

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };

  const handleClick = (data, id) => {
    setfundingSourceId(data.id);
    setSelectedID(id);
  };

  const getSelectedClass = (id) => (selectedID === id ? "#E0ECFF" : "");

  const onSubmit = async (data) => {
    if (addButton === true) {
      const accountGid = (preFillCustomer && preFillCustomer.account) ? (preFillCustomer && preFillCustomer.account && preFillCustomer.account.gid)
        : accountId ? accountId : paymentPageGId;
      const customerName = data.name;
      const email = data.email.trim();
      const customerEmail = encodeURIComponent(email);
      const payload = { customerName, customerEmail, accountGid };
      getClientSecret(payload);
    } else {
      if (recaptchaToken) {
        setShowCaptchError(null);
      } else {
        setShowCaptchError('Captcha is required');
      }
      const { name, email, phone, countryCallingCode } = data;
      const phoneNumber = phone ? countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}` : null;
      const customer = { name, email, phoneNumber };
      const finalData = { customer, fundingSourceId, recaptchaToken };
      if (isCaptchaEnabled) {
        if (recaptchaToken) {
          if (submit) { submit(finalData) }
        }
      } else {
        if (submit) { submit(finalData) }
      }
    }

  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  return (
    <HelmetProvider>
      {
        loading ? (
          <>
            <div style={{ marginLeft: '150px' }} className="spinner-border text-muted mr-4"> </div>
          </>
        ) : (
          <>
            <H1Text
              className="px-1 px-md-4 mb-0"
            >
              {headerText || "Pay With ACH"}
            </H1Text>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)(e);
              }}
              onChange={() => setShowErrorMessage(false)}
              style={{
                width: '100%',
              }}
            >
              <FlexContainer
                flexDirection="column"
              >
                <div className="px-1 px-md-4 mt-2">
                  <LabelText>
                    Name
                  </LabelText>
                  <Controller
                    defaultValue={""}
                    color={errors.name ? "red" : "inherit"}
                    marginBottom="0px"
                    control={control}
                    disabled={clientSecretKey ? true : false}
                    name="name"
                    placeholder="Enter your name"
                    rules={customerValidation && {
                      required: 'This field is required'
                    }}
                    as={<Input
                      readOnly={customerDisabled}
                      style={{
                        background: customerDisabled ? BACKGROUND_COLOR : '',
                        color: customerDisabled ? COLOR : ''
                      }}
                    />}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="name"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                  <LabelText>
                    E-Mail
                  </LabelText>
                  <Controller
                    marginBottom="0px"
                    defaultValue={""}
                    disabled={clientSecretKey ? true : false}
                    color={errors.email ? "red" : "inherit"}
                    control={control}
                    name="email"
                    placeholder="Enter your email address"
                    rules={customerValidation && {
                      required: 'This filed is required',
                      pattern: {
                        value: EMAIL.DEFAULT_REGEX,
                        message: 'The email is invalid',
                      },
                    }}
                    as={<Input
                      readOnly={customerDisabled}
                      style={{
                        background: customerDisabled ? BACKGROUND_COLOR : '',
                        color: customerDisabled ? COLOR : ''
                      }}
                    />}
                  />
                  <ErrorMessage
                    errors={errors}
                    name="email"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                  <LabelText>
                    Phone
                  </LabelText>
                  <InputWrapper className="row" display="flex" marginTop="8px" borderRadius="4px" width='299px'>
                    <Controller
                      defaultValue={""}
                      color={errors.countryCallingCode ? "red" : "inherit"}
                      marginBottom="0px"
                      control={control}
                      disabled={clientSecretKey ? true : false}
                      name="countryCallingCode"
                      placeholder="select"
                      rules={customerValidation && requiredPhone && {
                        required: 'Calling Code is required'
                      }}
                      as={<Select
                        className="col-4 px-0 border-0"
                        menuPlacement="auto"
                        isSearchable={!customerDisabled}
                        menuIsOpen={customerDisabled ? false : undefined}
                        theme={theme => ({
                          ...theme,
                          borderRadius: "4px 0 0 4px",
                          boxShadow: 0
                        })}
                        getOptionLabel={(option) => option.value}
                        styles={customerDisabled ? disableStyles : phoneCustomStyles}
                        options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
                    />
                    <Controller
                      className="col"
                      defaultValue={""}
                      color={errors.phone ? "red" : "inherit"}
                      border="0px !important"
                      marginBottom="0px"
                      marginTop="0px"
                      marginLeft="0px"
                      paddingRight="0"
                      control={control}
                      name="phone"
                      rules={customerValidation && requiredPhone && {
                        required: 'This filed is required',
                        validate: isPhoneNumberValidate
                      }}
                      as={<NumberFormat
                        type="tel"
                        allowNegative={false}
                        decimalScale={0}
                        readOnly={customerDisabled}
                        borderRadius="none"
                        style={{
                          background: customerDisabled ? BACKGROUND_COLOR : '',
                          color: customerDisabled ? COLOR : ''
                        }}
                      />}
                      placeholder="Enter your phone number"
                      customInput={Input}
                    />
                  </InputWrapper>
                  <ErrorMessage
                    errors={errors}
                    name="phone"
                    render={({ message }) => (
                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                    )}
                  />
                  {
                    sitekey && (isCaptchaEnabled === true) && (
                      <div className="mt-3">
                        <ReCAPTCHA
                          sitekey={sitekey}
                          value={recaptchaToken}
                          onChange={(value) => {
                            setRecaptchToken(value);
                            setShowCaptchError(null);
                          }}
                        />
                        {
                          (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                          ) : showCaptchError ? (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                          ) : ''
                        }
                      </div>
                    )
                  }
                  {
                    clientSecretKey && publicKey ? (
                      <div>
                        <div
                          className="mt-4 mb-2 ml-1"
                          style={{
                            fontWeight: '600',
                            fontSize: '14px',
                            lineHeight: '19px',
                            color: '#3B3B3B'
                          }}
                        >
                          Select Bank Account
                        </div>
                        <>
                          <Helmet>
                            <script src="https://js.stripe.com/v3/"></script>
                            <script>{`async function test(publicKey, clientSecretKey) {
          var stripe = await Stripe(publicKey);
        const results = await stripe.collectFinancialConnectionsAccounts({
        clientSecret: clientSecretKey
    })
        .then(function(result) {
            if (result.error) {
                // Inform the customer that there was an error.
                console.log(result.error.message, 'error inside stripe');
                sessionStorage.setItem("stripeRes", result.error.message);
                return result.error.message;
                // Handle next step based on length of accounts array
            } else if (result.financialConnectionsSession.accounts.length === 0) {
                console.log('No accounts were linked', 'error inside stripe');
                sessionStorage.setItem("stripeRes", 'No accounts were linked');
                return 'No accounts were linked';
            } else {
              console.log(result.financialConnectionsSession.accounts, 'result inside stripe');
              //const data = (result.financialConnectionsSession.accounts);
              sessionStorage.setItem("stripeRes", JSON.stringify(result.financialConnectionsSession.accounts));
              return result.financialConnectionsSession.accounts;
            }
        });
          }`}</script>
                          </Helmet>
                          {
                            (!response) && (
                              <div
                                style={{
                                  width: '299.57px',
                                  height: '40.1px',
                                  fontWeight: '600',
                                  fontSize: '13px',
                                  lineHeight: '16px',
                                  textAlign: 'center',
                                  color: '#3C3C3C',
                                  border: '1px solid #D9D9D9',
                                  borderRadius: '6px',
                                  paddingTop: '0.5rem',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  justifyContent: 'center',
                                }}
                                onClick={async () => {
                                  const res = await test(publicKey, clientSecretKey);
                                  setRedirect(true);
                                }}
                              >
                                <Img
                                  src={ACHIcon}
                                  alt='ach'
                                  style={{
                                    marginBottom: '6px',
                                  }}
                                /> <p style={{
                                  marginTop: '5px',
                                  marginLeft: '2px',
                                }}>Link Bank Accounts</p>
                              </div>
                            )
                          }
                          {
                            (name && response === true) ? (
                              <>
                                <AchPannel>
                                  {
                                    (name && response === true) ? (
                                      name.map((data, id) =>
                                        <div
                                          style={{
                                            backgroundColor: getSelectedClass(id),
                                          }}
                                        >
                                          <div
                                            onClick={() => handleClick(data, id)}
                                            style={{
                                              marginLeft: '1.5rem',
                                              paddingTop: '1.5rem',
                                            }}
                                          >
                                            <div
                                              className="mb-1"
                                              style={{
                                                fontWeight: '600',
                                                fontSize: '13px',
                                                color: '#3B3B3B',
                                                display: 'flex',
                                              }}
                                            >
                                              <Img
                                                src={ACHIcon}
                                                alt='ach'
                                                style={{
                                                  marginBottom: '6px',
                                                }}
                                              /> <p style={{
                                                marginTop: '5px',
                                                marginLeft: '5px',
                                              }}>{data.institution_name}</p>
                                            </div>
                                            <div
                                              className="mb-2"
                                              style={{
                                                fontWeight: '400',
                                                fontSize: '13px',
                                                color: '#3B3B3B',
                                                paddingLeft: '1.6rem'
                                              }}
                                            >
                                              {`XXXX XXXX ${data.last4}`}
                                            </div>
                                            <div
                                              style={{
                                                fontWeight: '400',
                                                fontSize: '13px',
                                                color: '#3B3B3B',
                                                paddingLeft: '1.6rem'
                                              }}
                                            >
                                              {data.display_name}
                                            </div>
                                            <Hr />
                                          </div>
                                        </div>
                                      )
                                    ) : <div className="mt-2">{name}</div>
                                  }
                                </AchPannel>
                                <div
                                  style={{
                                    width: '300px',
                                    fontWeight: '400',
                                    fontSize: '10px',
                                    color: '#333333',
                                    marginTop: '1rem',
                                  }}
                                >
                                  If you use Merchant names' services or purchase additional products periodically pursuant to Rocket Rides' terms, you authorize Rocket Rides to debit your bank account periodically.
                                  Payments that fall outside of the regular debits authorized above will only be debited after your authorization is obtained.
                                </div>
                              </>
                            ) : ''
                          }
                        </>
                      </div>
                    ) : ''
                  }
                  {
                    (serviceFee || serviceFeeRate || discount || subTotal) && (
                      <div class="mt-4">
                        <Hr />
                        <table class="table table-bordered mt-4">
                          <tbody>
                            <tr style={{ borderBottom: 'hidden' }}>
                              <th scope="row">Amount:</th>
                              <td>{prefix} {AmountDivideByHundred(amount)}</td>
                            </tr>
                            {
                              discount && discount !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Discount:</th>
                                  <td>{prefix} ({AmountDivideByHundred(discount)})</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              subTotal && subTotal !== 0 ? (
                                <tr>
                                  <th scope="row">Sub Total:</th>
                                  <td>{prefix} {AmountDivideByHundred(subTotal)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              tax && tax !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Tax:</th>
                                  <td>{prefix} {tax ? (AmountDivideByHundred(tax)) : 0.00}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            {
                              serviceFeeVal && serviceFeeVal !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Service Fee:</th>
                                  <td>{prefix} {AmountDivideByHundred(serviceFeeVal)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                              {
                                surcharge && surcharge !== 0 ? (
                                  <tr style={{ borderBottom: 'hidden' }}>
                                    <th scope="row">Surcharge:</th>
                                    <td>{prefix} {AmountDivideByHundred(surcharge)}</td>
                                  </tr>
                                ) : (
                                  <></>
                                )
                              }
                            {
                              tip && tip !== 0 ? (
                                <tr style={{ borderBottom: 'hidden' }}>
                                  <th scope="row">Tip:</th>
                                  <td>{prefix} {AmountDivideByHundred(tip)}</td>
                                </tr>
                              ) : (
                                <></>
                              )
                            }
                            <tr style={{ background: '#F7F7F7' }}>
                              <th scope="row">Total Payable:</th>
                              <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayable)}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    )
                  }
                  {
                    (serviceFeeEnabled === true) && (
                      <div className="px-1 px-md-4">
                        <div class="mt-4">
                          <table class="table table-bordered mt-4">
                            <tbody>
                              <tr style={{ borderBottom: 'hidden' }}>
                                <th scope="row">Amount:</th>
                                <td>{prefix} {AmountDivideByHundred(netAmount)}</td>
                              </tr>
                              <tr style={{ borderBottom: 'hidden' }}>
                                <th scope="row">Service Fee:</th>
                                <td>{prefix} {AmountDivideByHundred(serviceFeeAmount)}</td>
                              </tr>
                              <tr style={{ background: '#F7F7F7' }}>
                                <th scope="row">Total Payable:</th>
                                <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayableAmount)}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )
                  }
                  <div className="px-1 px-md-4">
                    <FlexContainer
                      width="100%"
                    >
                      {
                        showCancelButton && cancel &&
                        <SpanText
                          onClick={onCancel}
                          cursor="pointer"
                          color="#40A9FF"
                          textDecoration="underline"
                          className="cursor-pointer m-3 pt-3"
                        >{cancelButtonText || "Cancel"}</SpanText>
                      }
                      {
                        fundingSourceId ? (
                          <SubmitButton
                            type="submit"
                            onClick={() => setAddButton(false)}
                          >{buttonText || "PAY"}</SubmitButton>
                        ) : !clientSecretKey ? (
                          <SubmitButton
                            type="submit"
                          >Create Client Secret</SubmitButton>
                        ) : (
                          <SubmitButton
                            type="submit"
                            disabled
                          >{buttonText || "PAY"}</SubmitButton>
                        )
                      }
                    </FlexContainer>
                    {/* {isShowErrorMessage && <PaymentError header={errorHeader ? errorHeader : null} message={errorMsg ? errorMsg : errorMessage} />} */}
                    {(disableButtonText && (planStartDate < currentDateObject)) && <PaymentError header={disableButtonText} message={'For more information, please contact support@swirepay.com'} />}
                  </div>
                </div>
              </FlexContainer>
            </form>
          </>
        )
      }
    </HelmetProvider>
  )
};

export default BankPayment;
